export default __webpack_public_path__ + "static/carousell-os-car-valuation-500p-approved-dealers-f63c9f87eac955fae113b1002f4d7d15.svg";